import _initializerDefineProperty from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _createClass from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39;

import request from '@/utils/request';
import { wrapperFormPost, wrapperGet, wrapperPost } from '@/utils/http';
import { setRequestConfigDecorator, setResponsePipeDecorator } from 'decor-core';
import { baseURLConfig, handleGetTargetData, setLoadingDecorator, setMessageDecorator } from 'api/common';
export default new (_dec = setMessageDecorator({
  success: '留言成功！'
}), _dec2 = setMessageDecorator({
  msgKey: 'errorMsg'
}), _dec3 = setMessageDecorator({
  msgKey: 'errorMsg'
}), _dec4 = setMessageDecorator({
  msgKey: 'errorMsg'
}), _dec5 = setRequestConfigDecorator(baseURLConfig), _dec6 = setResponsePipeDecorator(handleGetTargetData), _dec7 = setRequestConfigDecorator(baseURLConfig), _dec8 = setMessageDecorator({
  msgKey: 'errorMsg'
}), _dec9 = setMessageDecorator({
  msgKey: 'errorMsg'
}), _dec10 = setMessageDecorator({
  msgKey: 'errorMsg'
}), _dec11 = setMessageDecorator({
  msgKey: 'errorMsg'
}), _dec12 = setMessageDecorator({
  msgKey: 'errorMsg'
}), _dec13 = setResponsePipeDecorator(handleGetTargetData), _dec14 = setMessageDecorator({
  msgKey: 'errorMsg'
}), _dec15 = setResponsePipeDecorator(handleGetTargetData), _dec16 = setResponsePipeDecorator(handleGetTargetData), _dec17 = setResponsePipeDecorator(handleGetTargetData), _dec18 = setResponsePipeDecorator(handleGetTargetData), _dec19 = setMessageDecorator({
  msgKey: 'errorMsg'
}), (_class = /*#__PURE__*/_createClass(function ActivityApi() {
  _classCallCheck(this, ActivityApi);

  _defineProperty(this, "getPlatformActivitys", wrapperGet('/api/client-ubq-app/platformActivity/pagePlatformActivitys/V3'));

  _initializerDefineProperty(this, "activityList", _descriptor, this);

  _defineProperty(this, "receiveList", wrapperPost('api/client-ubq-app/anniversary2/receive'));

  _initializerDefineProperty(this, "leaveMessageAdd", _descriptor2, this);

  _initializerDefineProperty(this, "leaveMessageCnt", _descriptor3, this);

  _initializerDefineProperty(this, "lotteryInfo", _descriptor4, this);

  _initializerDefineProperty(this, "lotteryMyAwards", _descriptor5, this);

  _defineProperty(this, "lotteryAvailableDrawNums", wrapperGet("/api/client-ubq-app/lottery/availableDrawNums"));

  _initializerDefineProperty(this, "lotteryRollingWinnerList", _descriptor6, this);

  _initializerDefineProperty(this, "lotteryDraw", _descriptor7, this);

  _defineProperty(this, "lotteryProgress", wrapperPost("/api/client-ubq-app/lottery/progress/"));

  _initializerDefineProperty(this, "anniversaryActivityTime", _descriptor8, this);

  _initializerDefineProperty(this, "anniversaryCarouselImg", _descriptor9, this);

  _initializerDefineProperty(this, "getCollectRank", _descriptor10, this);

  _initializerDefineProperty(this, "anniversaryMedalUnNfrMarkNum", _descriptor11, this);

  _initializerDefineProperty(this, "anniversaryOpenMedal", _descriptor12, this);

  _defineProperty(this, "getLotteryInfo", wrapperGet('/api/client-ubq-app/lottery/info'));

  _defineProperty(this, "getRollingWinnerList", wrapperGet('/api/client-ubq-app/lottery/rollingWinnerList'));

  _defineProperty(this, "smeltingNfrList", wrapperPost('/api/client-ubq-app/lottery/smeltingNfrList'));

  _initializerDefineProperty(this, "smeltingNfr", _descriptor13, this);

  _defineProperty(this, "isNeedSmsVerify", wrapperPost('/api/client-ubq-app/lottery/isNeedSmsVerify'));

  _initializerDefineProperty(this, "getCodeInfo", _descriptor14, this);

  _initializerDefineProperty(this, "openBlindBox", _descriptor15, this);

  _defineProperty(this, "openBlindBoxByThirdParty", wrapperPost('/api/client-ubq-app/scan/openBlindBoxByThirdParty'));

  _initializerDefineProperty(this, "updateCoverImg", _descriptor16, this);

  _defineProperty(this, "getFindByActivity", wrapperGet('/api/client-ubq-app/quiz/findByActivityKey'));

  _initializerDefineProperty(this, "setQuizSubmit", _descriptor17, this);

  _defineProperty(this, "getFindUserQuizScore", wrapperGet('/api/client-ubq-app/quiz/findUserQuizScore'));

  _initializerDefineProperty(this, "getWorldCupConfig", _descriptor18, this);

  _initializerDefineProperty(this, "getMyCoinCount", _descriptor19, this);

  _initializerDefineProperty(this, "getTaskDetail", _descriptor20, this);

  _initializerDefineProperty(this, "getGuessRound", _descriptor21, this);

  _initializerDefineProperty(this, "getGuessSession", _descriptor22, this);

  _initializerDefineProperty(this, "guessingCompetition", _descriptor23, this);

  _initializerDefineProperty(this, "getCurrencyDetail", _descriptor24, this);

  _initializerDefineProperty(this, "getPrizeList", _descriptor25, this);

  _initializerDefineProperty(this, "getGuessExchangeRecode", _descriptor26, this);

  _initializerDefineProperty(this, "getStoreAliveInvite", _descriptor27, this);

  _initializerDefineProperty(this, "getInviteActivity", _descriptor28, this);

  _initializerDefineProperty(this, "getMyInviteInfo", _descriptor29, this);

  _initializerDefineProperty(this, "getInviteRecordList", _descriptor30, this);

  _initializerDefineProperty(this, "checkAssist", _descriptor31, this);

  _initializerDefineProperty(this, "inviteActivityAssist", _descriptor32, this);

  _defineProperty(this, "wishRaffle", wrapperPost("/api/client-ubq-app/wishRaffle/wishRaffle"));

  _defineProperty(this, "getWishStatus", wrapperGet("/api/client-ubq-app/wishRaffle/getWishStatus"));

  _defineProperty(this, "getShareNo", wrapperGet("/api/client-ubq-app/wishRaffle/share"));

  _defineProperty(this, "assistance", wrapperPost("/api/client-ubq-app/wishRaffle/assistance"));

  _defineProperty(this, "getBlessing", wrapperGet("/api/client-ubq-app/wishRaffle/getBlessing"));

  _initializerDefineProperty(this, "findActInfo", _descriptor33, this);

  _initializerDefineProperty(this, "getAttrNow", _descriptor34, this);

  _initializerDefineProperty(this, "bakenActLottery", _descriptor35, this);

  _initializerDefineProperty(this, "pagedRwdRecord", _descriptor36, this);

  _initializerDefineProperty(this, "fillRewardAddr", _descriptor37, this);

  _initializerDefineProperty(this, "bakenActAssist", _descriptor38, this);

  _initializerDefineProperty(this, "guessExchange", _descriptor39, this);
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "activityList", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/client-ubq-app/anniversary2/activitiesInfo');
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "leaveMessageAdd", [_dec, setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPost('/api/client-ubq-app/common/leaveMessage/add');
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "leaveMessageCnt", [_dec2, setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/client-ubq-app/common/leaveMessage/cnt');
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "lotteryInfo", [_dec3, setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/client-ubq-app/lottery/info');
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "lotteryMyAwards", [_dec4, setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPost('/api/client-ubq-app/lottery/myAwards');
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "lotteryRollingWinnerList", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet("/api/client-ubq-app/lottery/rollingWinnerList");
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "lotteryDraw", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperFormPost('/api/client-ubq-app/lottery/draw');
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "anniversaryActivityTime", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/client-ubq-app/anniversary/activitiesInfo');
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "anniversaryCarouselImg", [_dec6, _dec7, setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/client-ubq-app/anniversary/carouselImgs');
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "getCollectRank", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/client-ubq-app/common/mysteryReward/pagedCollectRanking');
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "anniversaryMedalUnNfrMarkNum", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/client-ubq-app/memberUserInfo/findMedalUnNfrMarkNum');
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "anniversaryOpenMedal", [_dec8, setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPost('/api/client-ubq-app/common/medalAwaken/openMedal');
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "smeltingNfr", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPost('/api/client-ubq-app/lottery/smeltingNfr');
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "getCodeInfo", [_dec9, setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/client-ubq-app/scan/getCodeInfo');
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "openBlindBox", [_dec10, setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPost('/api/client-ubq-app/scan/openBlindBox');
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "updateCoverImg", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPost('/api/client-ubq-app/client/nft/updateCoverImg');
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "setQuizSubmit", [_dec11, setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPost('/api/client-ubq-app/quiz/quizSubmit');
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "getWorldCupConfig", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/client-ubq-app/worldCupActivity/findTaskList');
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "getMyCoinCount", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/client-ubq-app/worldCupActivity/findCurrencyNumber');
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "getTaskDetail", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/client-ubq-app/worldCupActivity/findBuyTaskDetail');
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "getGuessRound", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/client-ubq-app/worldCupActivity/findJumpRound');
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "getGuessSession", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/client-ubq-app/worldCupActivity/findSessions');
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "guessingCompetition", [_dec12, setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPost('/api/client-ubq-app/worldCupActivity/guessingCompetition');
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "getCurrencyDetail", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/client-ubq-app/worldCupActivity/findCurrencyDetail');
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "getPrizeList", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/client-ubq-app/worldCupActivity/findPrizes');
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "getGuessExchangeRecode", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/client-ubq-app/worldCupActivity/findPrizeRecord');
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "getStoreAliveInvite", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet("/api/client-ubq-app/inviteAct/findStoreAliveInvite");
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "getInviteActivity", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet("/api/client-ubq-app/inviteAct/findInviteActInfo");
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "getMyInviteInfo", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet("/api/client-ubq-app/inviteAct/myInviteInfo");
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "getInviteRecordList", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPost("/api/client-ubq-app/inviteAct/pagedInviteLog");
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "checkAssist", [setLoadingDecorator, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet("/api/client-ubq-app/inviteAct/hasAssist");
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "inviteActivityAssist", [_dec14, setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPost("/api/client-ubq-app/inviteAct/assist");
  }
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "findActInfo", [_dec15, setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet("/api/client-ubq-app/bakenAct/findActInfo");
  }
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "getAttrNow", [_dec16, setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet("/api/client-ubq-app/bakenAct/getAttrNow");
  }
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "bakenActLottery", [_dec17, setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPost("/api/client-ubq-app/bakenAct/lottery");
  }
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "pagedRwdRecord", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPost("/api/client-ubq-app/bakenAct/pagedRwdRecord");
  }
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "fillRewardAddr", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPost("/api/client-ubq-app/bakenAct/fillRewardAddr");
  }
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "bakenActAssist", [_dec18, setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPost("/api/client-ubq-app/bakenAct/assist");
  }
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "guessExchange", [_dec19, setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function (id) {
      return wrapperPost("/api/client-ubq-app/worldCupActivity/exchangePrize?prizeNo=".concat(id));
    };
  }
})), _class))(); // 邀请好友=》领取数字人民币（通用接口）

export function getFriendDisshareEventCommit(data) {
  return request({
    url: '/api/opuser/spread/shareEventCommit',
    method: 'POST',
    data: data
  });
} // 获取进度（通用接口）

export function spreadShareProcess(data) {
  return request({
    url: '/api/opuser/spread/shareProcess',
    method: 'POST',
    data: data
  });
} // 获取投票活动nfr、元宝资源

export function getVoteResource(params) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  return request({
    url: '/api/opactivity/voteElection/getVoteResource/' + params,
    method: method
  });
} // 一键兑换元宝

export function batchExchangeVotes(data) {
  return request({
    url: '/api/opactivity/voteElection/batchExchangeVotes/' + data,
    method: 'POST'
  });
} // 查询投票详情

export function getVoteProjectInfo(params) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  return request({
    url: '/api/client-ubq-app/vote/getProjectInfo?privilegeTemplateNo=' + params,
    method: method
  });
} // 查询投票项目

export function getVoteProject(params) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  return request({
    url: '/api/opactivity/voteElection/getVoteProject/' + params,
    method: method
  });
} // 查询我的助力

export function pageVotesRecord(data) {
  return request({
    url: '/api/opactivity/voteElection/pageVotesRecord',
    method: 'POST',
    data: data
  });
} // 助力投票

export function launchVotePrj(data) {
  return request({
    url: '/api/opactivity/voteElection/launchVotePrj',
    method: 'POST',
    data: data
  });
} // 查询助力记录

export function votesRecord(data) {
  return request({
    url: '/api/opactivity/voteElection/pageVotesRecord',
    method: 'POST',
    data: data
  });
} // 活动结果页数据查询

export function getActivityResult(id) {
  return request({
    url: "/api/opactivity/voteElection/getActivityResult/".concat(id),
    method: 'get'
  });
} // 元宵点亮星星活动 -获取任务奖励进度、兑换次数、总进度等

export function getTaskProgress(params) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  return request({
    url: '/api/client-ubq-app/activityTask/taskProgress',
    method: method,
    params: params
  });
} // 获取奖励历史记录

export function getRewardHistory(params) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  return request({
    url: '/api/client-ubq-app/activityTask/getRewardHistory',
    method: method,
    params: params
  });
}